import React from 'react';
import { noop } from 'lodash';

const PlaceBetContext = React.createContext<VoidFn>(noop);

export default PlaceBetContext;
